<!--权重评分 WRQ-->
<template>
  <div class="question-container" style="border: 1px solid #edeff2">
    <div class="question-type">权重评分</div>
    <div class="title-view" :style="{ marginRight: '' }">
      <p style="color: #4c4a56">
        <span v-if="dataObj.isMust === 1" class="asterisk">*</span>
        {{ `${dataObj.questionIndex ? dataObj.questionIndex : index + 1}、` }}
        <span style="color: #4c4a56">{{ dataObj.caseProblem }}</span>
      </p>
    </div>

    <div class="question-images">
      <div
        v-for="(item, index) in images"
        :key="index"
        style="margin-top: 10px; position: relative"
      >
        <img :src="item" mode="widthFix" style="width: 100%" />
      </div>
    </div>

    <div v-for="(item, index) in list" :key="index" class="evaluate-view">
      <div class="evaluate-view-score">
        <span class="sub-title">{{ item.text }}：</span>
        <span class="sub-title">{{ item.value || 0 }}分</span>
      </div>
      <div>
        <el-slider
          v-model="item.value"
          :min="0"
          :max="item.score"
          :step="1"
        ></el-slider>
      </div>

      <div class="question-images">
        <div
          class="question-images-box"
          @click.stop="showBigImage(imgItem, item)"
          v-for="(imgItem, imgIndex) in item.img_path"
          :key="imgIndex"
          style="margin-top: 10px; position: relative"
        >
          <img :src="imgItem" mode="aspectFill" class="thumbnail-image" />
          <div class="fangda-box">查看图片</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    params: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      dataObj: {},
      index: 0,
      images: [],
      list: [],
    };
  },
  watch: {
    params: {
      handler(newVal) {
        this.dataObj = newVal.data;
        this.index = newVal.index;
        this.images = JSON.parse(newVal.data.caseProblemImg || "[]");
        this.list = JSON.parse(newVal.data.chooseList).list;

        if (newVal.answer && Array.isArray(newVal.answer.answer)) {
          const answers = newVal.answer.answer;
          this.list.forEach((item) => {
            const matched = answers.find((ans) => ans.id === item.id);
            item.value = matched ? Number(matched.context) : 0;
          });
        } else {
          this.list.forEach((item) => {
            item.value = 0;
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
.evaluate-view {
  width: 100%;
  padding: 25px;
  box-sizing: border-box;
  background-color: #f9f9f9;
  border-radius: 3px;
  margin-top: 25px;
}

.evaluate-view-score {
  width: 100%;
  text-align: left;
}

.sub-title + .sub-title {
  color: #3a60ff;
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/QuestionPreview/QuestionPreviewWRQ.vue